import type { enWhite } from "./en.white";

/** Russian for the white-page pool screen (see `en.white.ts`). */
export const ruWhite: Record<keyof typeof enWhite, string> = {
  "white.nav": "White-пул",
  "white.title": "White-пул",
  "white.subtitle": "Безопасные страницы, которые видят модерация и боты вместо оффера. У каждой связки свой white; время — киевское.",
  "white.port": "Генератор",
  "white.port.manual": "Только загрузка ZIP",
  "white.newCell": "Добавить ячейку",
  "white.tab.matrix": "Матрица",
  "white.tab.categories": "Категории",
  "white.tab.refills": "Пополнения",
  "white.sum.fresh": "Свежих",
  "white.sum.consumed": "Ушло за 7 дней",
  "white.sum.low": "Ячеек ниже порога",
  "white.sum.pending": "Связок ждут white",
  "white.sum.today": "Заказано сегодня",
  "white.sum.todayDetail": "ночью {night} · днём {day} · срочно {urgent}",
  "white.color.enough": "Хватает",
  "white.color.tight": "Впритык",
  "white.color.low": "Ниже порога",
  "white.color.ordered": "Заказ в пути",
  "white.color.off": "Выключена",
  "white.matrix.category": "Категория",
  "white.matrix.empty.title": "Ячеек пока нет",
  "white.matrix.empty.text": "Ячейка — это категория в одной стране и на одном языке. Добавьте её или создайте связку с автоматическим white — она добавит свою сама.",
  "white.matrix.noCategories.title": "Начните с категории",
  "white.matrix.noCategories.text": "Категория говорит, каким офферам достаются её white (по тегам оффера) и каким пресетом генератора они делаются.",
  "white.matrix.add": "Добавить {geo} / {lang}",
  "white.matrix.cellAria": "{category}, {geo} / {lang}: свежих {fresh} из {target}",
  "white.matrix.pick": "Выберите ячейку — увидите её white, сможете загрузить ZIP или пополнить.",
  "white.cell.fresh": "свежих",
  "white.cell.target": "цель {target} · порог {threshold}",
  "white.cell.ordered": "+{n} в пути",
  "white.cell.pending": "ждут: {n}",
  "white.panel.close": "Закрыть",
  "white.panel.stats.assigned": "В связках",
  "white.panel.stats.burned": "Сожжено",
  "white.panel.stats.consumed": "Ушло за 7 дней",
  "white.panel.stats.pending": "Связок ждут",
  "white.panel.targetNote": "Цель пересчитывается каждую ночь в 02:00: расход прошлой недели в день × 1,5, но не меньше {min}.",
  "white.panel.threshold": "Порог",
  "white.panel.threshold.hint": "Когда свежих столько или меньше, ячейка сразу заказывает ещё. Пусто — порог категории ({n}).",
  "white.panel.enabled": "Ячейка включена",
  "white.panel.save": "Сохранить",
  "white.panel.saved": "Ячейка сохранена",
  "white.panel.refill": "Пополнить сейчас",
  "white.panel.refill.manual": "Генератор не подключён или у категории нет пресета — загрузите ZIP.",
  "white.panel.refilled": "Заказано сайтов: {n}",
  "white.panel.import": "Загрузить ZIP",
  "white.panel.import.drop": "Перетащите ZIP сайта сюда",
  "white.panel.import.hint": "index.html в корне, до 25 МБ. {local} уже должен быть заменён; {domain} станет доменом, на котором открыта страница.",
  "white.panel.import.tooBig": "ZIP больше 25 МБ — уменьшите архив.",
  "white.panel.imported": "White добавлен в пул",
  "white.panel.zipOnly": "Нужен архив .zip",
  "white.panel.whites": "White ячейки",
  "white.panel.whites.empty": "Здесь пока нет white.",
  "white.state.all": "Все",
  "white.state.fresh": "Свежие",
  "white.state.assigned": "В связке",
  "white.state.burned": "Сожжённые",
  "white.white.made": "добавлен {at}",
  "white.white.assigned": "{campaign} с {at}",
  "white.white.burned": "сожжён {at}: {reason}",
  "white.white.preview": "Открыть",
  "white.white.burn": "Сжечь",
  "white.burn.title": "Сжечь этот white?",
  "white.burn.text": "Его больше никому не выдадут. Связка, которая его держит, получит следующий свежий white ячейки.",
  "white.burn.reason": "Причина",
  "white.burn.reason.placeholder": "Не прошёл модерацию…",
  "white.burn.confirm": "Сжечь",
  "white.burn.cancel": "Отмена",
  "white.burned": "White сожжён",
  "white.cat.new": "Новая категория",
  "white.cat.edit": "Категория",
  "white.cat.empty": "Категорий пока нет.",
  "white.cat.col.title": "Категория",
  "white.cat.col.tags": "Теги офферов",
  "white.cat.col.preset": "Пресет",
  "white.cat.col.limits": "Мин. цель / порог",
  "white.cat.col.contact": "Адрес для связи",
  "white.cat.none": "—",
  "white.cat.off": "Выключена",
  "white.cat.delete": "Удалить",
  "white.cat.delete.title": "Удалить категорию «{title}»?",
  "white.cat.delete.text": "Удалить можно только категорию без white. Её ячейки уйдут вместе с ней.",
  "white.cat.deleted": "Категория удалена",
  "white.cat.saved": "Категория сохранена",
  "white.cat.f.title": "Название",
  "white.cat.f.title.placeholder": "Суставы…",
  "white.cat.f.key": "Ключ",
  "white.cat.f.key.hint": "По нему категорию называет кабинет; потом не меняется.",
  "white.cat.f.tags": "Теги офферов",
  "white.cat.f.tags.hint": "Связка, у оффера которой есть один из этих тегов, берёт white этой категории.",
  "white.cat.f.tags.placeholder": "Выберите тег…",
  "white.cat.f.preset": "Пресет генератора",
  "white.cat.f.preset.none": "Без пресета — только загрузка ZIP",
  "white.cat.f.preset.manual": "Генератор не подключён: категория принимает только загруженные ZIP.",
  "white.cat.f.targetMin": "Минимальная цель",
  "white.cat.f.reorderAt": "Порог",
  "white.cat.f.reorderAt.hint": "Когда свежих столько или меньше, ячейка сразу заказывает ещё.",
  "white.cat.f.contact": "Контакты на сайте",
  "white.cat.f.contact.name": "Имя для связи",
  "white.cat.f.contact.email": "Шаблон e-mail",
  "white.cat.f.contact.email.hint": "{local} подставит генератор, {domain} — трекер, доменом страницы. Будет видно: {preview}",
  "white.cat.f.contact.host": "Адрес сайта",
  "white.cat.f.contact.city": "Показывать адрес в городе",
  "white.cat.f.contact.form": "Форма обратной связи",
  "white.cat.f.contact.noPhone": "Телефон на white не пишется никогда.",
  "white.cat.f.enabled": "Категория включена",
  "white.cat.f.save": "Сохранить",
  "white.cat.f.cancel": "Отмена",
  "white.cat.f.err.key": "Строчные латинские буквы, цифры, «_», «-», «.»; начинается с буквы или цифры",
  "white.cat.f.err.title": "Назовите категорию",
  "white.cat.f.err.range": "От {min} до {max}",
  "white.newCell.title": "Добавить ячейку",
  "white.newCell.text": "Категория в одной стране и на одном языке. Связки этого рынка берут white из неё.",
  "white.newCell.category": "Категория",
  "white.newCell.geo": "Страна",
  "white.newCell.lang": "Язык",
  "white.newCell.create": "Добавить",
  "white.newCell.created": "Ячейка добавлена",
  "white.newCell.err.required": "Обязательно",
  "white.refills.empty": "Заказов пока нет. Первый ночной прогон — в 02:00.",
  "white.refills.col.at": "Заказан",
  "white.refills.col.cell": "Ячейка",
  "white.refills.col.kind": "Почему",
  "white.refills.col.state": "Состояние",
  "white.refills.col.sites": "Сайтов: заказано / готово / взято",
  "white.refills.col.error": "Проблема",
  "white.kind.night": "Ночной прогон",
  "white.kind.threshold": "Порог",
  "white.kind.urgent": "Срочно, для связки",
  "white.kind.manual": "Пополнить сейчас",
  "white.refill.creating": "Отправляется",
  "white.refill.open": "Генерируется",
  "white.refill.done": "Готово",
  "white.refill.failed": "Не удалось",
  "white.refill.cancelled": "Отменён",
  "white.loadFailed": "Не удалось загрузить white-пул",
};
